module.exports = __webpack_public_path__ + "115d8f2d0e054ba7dd2b4220447a828d.jpg";